import React, { useEffect, useState } from "react";
import { Flex, useColorModeValue } from "@chakra-ui/react";
import HorizonLogo from "assets/img/zokep.png";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  const [logoSrc, setLogoSrc] = useState(HorizonLogo);
  
  useEffect(() => {
    const userType = localStorage.getItem('type');
    const storedLogo = localStorage.getItem('logo');
    
    // For SuperAdmin and SuperAdmin2, use default logo
    if (userType === 'SuperAdmin' || userType === 'SuperAdmin2') {
      setLogoSrc(HorizonLogo);
    } 
    // For other roles, use the logo from localStorage if available
    else if (storedLogo) {
      setLogoSrc(storedLogo);
    }
  }, []);

  return (
    <Flex align='center' direction='column'>
      <img src={logoSrc} className="w-[180px] my-[10px]" alt="Logo"/>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
